import * as Sentry from '@sentry/nextjs';

import {
  type GetStockStatusInput,
  type StockStatusResult,
  article as articleService,
  stock,
} from '@boss/services/client';

const fetchStockByWarehouseIds = async ({
  skus,
  warehouseIds,
  locale,
}: {
  skus: {
    skuid: string;
    quantity?: number;
    unit?: string;
  }[];
  warehouseIds: string[];
  locale: string;
}) => {
  try {
    return await articleService.getArticleStockByWarehouseIds({ skus, warehouseIds, locale });
  } catch (e) {
    Sentry.captureException(e, {
      tags: {
        type: 'Fetch stock by warehouse ids',
      },
    });
  }
};

const fetchStockStatus = async ({
  skus,
  deliveryMethod,
  shopWarehouseCode,
  locale,
  translations,
}: GetStockStatusInput): Promise<StockStatusResult | undefined> => {
  try {
    return await stock.getStockStatus({ skus, deliveryMethod, shopWarehouseCode, locale, translations });
  } catch (e) {
    Sentry.captureException(e, {
      tags: {
        type: 'Fetch stock status',
      },
    });
  }
};

export { fetchStockByWarehouseIds, fetchStockStatus };
